var map = {
	"./Agoco-login.png": 9564,
	"./Agoco-logo.png": 8848,
	"./Agoco-min.png": 8862,
	"./Agoco_login_footer_logo.png": 9908,
	"./Alitheflow.png": 6613,
	"./Alitheflow_sygnet.png": 5981,
	"./Championx.svg": 5462,
	"./Endurance-logo.png": 9799,
	"./Endurance-min.png": 3828,
	"./Mellitah.png": 1311,
	"./Mellitah_Logo.png": 5817,
	"./WellLynx-logo.png": 4704,
	"./WellLynx-min.png": 1338,
	"./akakus-logo.png": 758,
	"./akakus-min.png": 4061,
	"./championx-logo.png": 5743,
	"./championx-min.png": 4776,
	"./driveLynx-logo.png": 7240,
	"./driveLynx-logo.svg": 8354,
	"./driveLynx-min.svg": 3132,
	"./driveLynxresized.png": 4475,
	"./halliburton-logo.png": 1957,
	"./halliburton-min.png": 5019,
	"./harouge-logo.png": 4501,
	"./harouge-logo.svg": 1420,
	"./harouge-min.svg": 4623,
	"./novomet-logo.png": 6756,
	"./novomet-min.png": 2793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2678;